export const authTypes = {
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  WATCH_LOGIN: "WATCH_LOGIN",
  LOGOUT: "LOGOUT",
  CLEAR_AUTH_ERROR: "CLEAR_AUTH_ERROR",
  AUTO_LOGOUT: "AUTO_LOGOUT",
  CHOOSE_USER_ORGANIZATION: "CHOOSE_USER_ORGANIZATION",
  UPDATE_AUTH: "UPDATE_AUTH",
  CLEAR_NOTIFICATION : "CLEAR_NOTIFICATION"
};

export const loginRequest = (credentials) => ({
  type: authTypes.LOGIN_REQUEST,
  payload: credentials,
});

export const loginSuccess = (user) => ({
  type: authTypes.LOGIN_SUCCESS,
  payload: user,
});

export const loginFailure = (error) => ({
  type: authTypes.LOGIN_FAILURE,
  payload: error,
});

export const watchLogin = () => ({
  type: authTypes.WATCH_LOGIN,
});

export const logout = () => ({
  type: authTypes.LOGOUT,
});
export const clearAuthError = () => ({
  type: authTypes.CLEAR_AUTH_ERROR,
});

export const autoLogout = (isAutoLogout) => ({
  type: authTypes.AUTO_LOGOUT,
  payload: isAutoLogout
});

export const chooseUserOrganization = (currentUser) => ({
  type: authTypes.CHOOSE_USER_ORGANIZATION,
  payload: currentUser
});

export const updateAuth = (req) => ({
  type: authTypes.UPDATE_AUTH,
  payload: req
});
export const clearNotification = (req) => ({
  type: authTypes.CLEAR_NOTIFICATION,
  payload: req
});